import { Button, Dialog, DialogActions, DialogContent, DialogTitle, TextField, withWidth, isWidthDown } from '@material-ui/core'
import IconButton from '@material-ui/core/IconButton'
import FilterListIcon from '@material-ui/icons/FilterList'
import CloseIcon from '@material-ui/icons/Close'
import Axios from 'axios'
import MaterialTable, { MTableToolbar } from 'material-table'
import React, { Component } from 'react'
import { connect } from 'react-redux'
import { getTypeProduit, getStade, getMetaux } from '../actions'
import FilterInput from './filterInput'
import FilterSelect from './filterSelect'
import { apiATC, imagesRepo, localization, meekroDB } from '../config'
import TreeClient from '../components/treeClient'
import Image from 'react-bootstrap/Image'

import { euroFormat, exportCsv } from '../helpers/functions'
import AddStockProduit from './stock/AddStockProduit'
import EditStockProduit from './stock/EditStockProduit'
import HistoriqueStockProduit from './stock/HistoriqueStockProduit'
import TracerOf from '../containers/tracerOf'
import EnvoyerProduitsDialog from './stockProduit/ReservationDialog'
class StockPierre extends Component {

    state = {
        ref: '',
        of: '',
        listeOf: '',
        plateau: '',
        plateauForUptade: '',
        client: '',
        reservation: '',
        type: '',
        stade: '',
        metal: '',
        editer: false,
        modifier: false,
        ajouter: false,
        showPlateau: false,
        cpt: 0,
        totalVente: 0,
        totalRevient: 0,
        cptRevientNull: 0,
        totalRevientReproduction: 0,
        cptRevientReprodNull: 0,
        affecterClient: '',
        listeProduits: '',
        historique: false,
        dataHistorique: null,
        stockProduit: [],
        ofToTrace: '',
        open: false,
        poidsTotal:0,
        filterOpen: false,
    }
    componentDidMount() {
        this.props.getTypeProduit()
        this.props.getStade()
        this.props.getMetaux()
    }
    onChange = (data, labelState) => {
        const label = labelState.toLowerCase()
        this.setState({ [label]: data })
    }
    afficher = () => {
        const data = {
            agences: this.state.client,
            reservation: this.state.reservation,
            ref: this.state.ref,
            stade: this.state.stade,
            of: this.state.of,
            metal: this.state.metal,
            type: this.state.type,
            plateau: this.state.plateau,
            stockProduit: null,

        }
        Axios.post(`${apiATC}/produit/stock.php?action=liste`, data)
            .then((response) => {
                //console.log(response.data);
                // Normaliser la structure de la réponse : array possible sous .data / .liste ou la racine
                const raw = response.data || []
                const stockProduit = Array.isArray(raw) ? raw : (raw.data || raw.liste || raw)
                let cpt = 0, totalVente = 0, totalRevient = 0, totalRevientReproduction = 0, cptRevientNull = 0, cptRevientReprodNull = 0, poidsTotal = 0;

                Object.values(stockProduit).forEach(p => {
                    cpt++
                    totalVente += parseFloat(p.leprix !== 0 ? p.leprix : p.total3)
                    if (p.prix_r === 0) cptRevientNull++;
                    totalRevient += parseFloat(p.prix_r)
                    poidsTotal += parseFloat(p.poids)
                    if (p.id_stade === 1) p.revient_prod = p.revient_mfs;
                    else if (p.id_stade === 3) p.revient_prod = p.revient_cv;
                    else if (p.id_stade === 4 || p.id_stade === 2) p.revient_prod = p.revient_piece;
                    else p.revient_prod = 0;
                    if (p.revient_prod === 0) cptRevientReprodNull++;
                    totalRevientReproduction += parseFloat(p.revient_prod)
                })
                this.setState({ stockProduit, cpt, totalVente: parseInt(totalVente), totalRevient: parseInt(totalRevient), totalRevientReproduction: parseInt(totalRevientReproduction), cptRevientNull, cptRevientReprodNull, poidsTotal })
            })
            .catch(error => {
                console.log(error);
            });

    }
    mouvementStock = (stockProduit, client) => {
        const data = {
            prods: stockProduit,
            id_clt: client,
        }
        Axios.post(`${meekroDB}/produit/mouvement.php`, data)
            .then((response) => {
                //console.log(response);
                this.afficher()
            })
            .catch(error => {
                console.log(error);
            });
    }
    supprimerResa = (stockProduit) => {
        let listeOF = "";
        stockProduit.forEach(element => {
            if (element.of) {
                if (listeOF !== "") {
                    listeOF += ",";
                }
                listeOF += element.of;
            }
        });
        const data = {
            table: 'of',
            primaryKey: 'of_reservation',
            id: listeOF,
            of_reservation: 0,
        };
        Axios.post(`${apiATC}/general.php?action=modifier`, data)
            .then((response) => {
                this.afficher();
            })
            .catch(error => {
                alert("Erreur lors de la requête Axios : " + error);
            });

    }


    mouvementPlateau = (stockProduit) => {
        let listeOf = '', sep = ''
        Object.values(stockProduit).forEach(r => {
            listeOf += sep + r.of
            sep = ','
        })
        this.setState({ showPlateau: true, listeOf })

    }
    facturer = (stockProduit) => {
        let listeOf = '', sep = ''
        Object.values(stockProduit).forEach(r => {
            const ofs = {
                table: 'of',
                primaryKey: 'num_sachet',
                id: r.of,
                prix_fact: r.leprix === 0 ? r.total3 : r.leprix,
                statut: 575,
                ref_clt: 'Confie ' + r.de,
                echeance: 0,
                date_paiement: '0000-00-00',
            }
            listeOf += sep + r.of
            sep = ','
            Axios.put(`${apiATC}/general.php?action=modifier`, ofs)
                .then((response) => {

                })
                .catch(error => {
                    console.log(error);
                });
        })
        const data = {
            ofids: listeOf
        }
        Axios.post(`${meekroDB}/produit/facturer_stock.php`, data)
            .then((response) => {
                this.afficher()
            })
            .catch(error => {
                console.log(error);
            });
    }
    affectMouvementPlateau = () => {
        const data = {
            table: 'new_stock_prod',
            primaryKey: 'of',
            id: this.state.listeOf,
            plateau: this.state.plateauForUptade,
        }
        Axios.put(`${apiATC}/general.php?action=modifier`, data)
            .then((response) => {
                // console.log(response);
                this.afficher()
            })
            .catch(error => {
                console.log(error);
            });
    }
    listeStockProduit = () => {
        const sp = this.state.stockProduit || []
        if (Array.isArray(sp)) return sp
        if (sp.data && Array.isArray(sp.data)) return sp.data
        if (sp.liste && Array.isArray(sp.liste)) return sp.liste
        return Object.values(sp)
    }
    editStock = (data) => {
        this.setState({ modifier: true, listeProduits: data })
    }
    handleChangeClient = (data) => {
        this.setState({ client: data })
    }
    handleChangeReservation = (data) => {
        this.setState({ reservation: data })
    }
    EnvoiClient = (data) => {
        this.setState({ affecterClient: data })
    }
    handleSave = e => {
        e.preventDefault()
        this.mouvementStock(this.state.listeProduits, this.state.affecterClient)
    }
    handleResa = e => {
        e.preventDefault()
        this.mouvementResa(this.state.listeProduits, this.state.affecterClient)
    }
    add = e => {
        this.setState({ ajouter: true })
    }
    historique = (of) => {

        Axios.get(`${meekroDB}/produit/mouvement.php?of=${of}`)
            .then((response) => {
                //console.log(response);
                this.setState({ dataHistorique: response.data, historique: true })
            })
            .catch(error => {
                console.log(error);
            });

    }
    etiquette = () => {
        var output = '';
        // eslint-disable-next-line
        var errorString = '';
        var price = 0;
        const getLabelMetal = (metal) => {
            switch (metal) {
                case "OR BLANC":
                    return "OR B ";
                case "OR ROSE":
                    return "OR R ";
                case "OR JAUNE":
                    return "OR J ";
                default:
                    return metal + " ";
            }
        }
        //var priceRep = 0;
        this.state.stockProduit && Object.values(this.state.stockProduit).forEach(p => {
            // console.log(p);
            if (p.leprix !== 0) price = p.leprix;
            else price = p.total3;
            let marque = "";
            if (p.nom_ligne === "EXTENSIA") marque = "EXTENSIA ";
            else marque = "ATC ";
            // priceRep = Math.round(price / 0.9);
            if (p.label_produit.length > 15) errorString += 'Attention OF N° ' + p.of + ' : Description trop grande\n';
            output += 'VAR1$="' + p.ref + ' - ' + p.poids + ' Gr" \n';
            output += 'VAR2$="' + p.label_produit + '"\n';
            //output+='VAR3$="'+ p.lemetal+ ' "\n' ;
            if (Math.round(price) < 6000 && Math.round(p.total3) < 6000) {
                output += 'VAR3$="' + price + '/' + Math.round(price * 2.5) + '"\n';
            }
            else output += 'VAR3$="' + price + ' € HT"\n';
            output += 'VAR4$="' + p.prenom_ligne.toUpperCase() + '"\n';
            output += 'VAR5$="' + getLabelMetal(p.lemetal) + p.of + '"\n';
            output += 'VAR6$="' + marque + '"\n';
            output += 'A=0001\n';
            output += 'LAYOUT1\n\n';
        })

        if (errorString !== '') alert(errorString);
        navigator.clipboard.writeText(output);
        return output;
    }
    reserver = () => {

    }
    imprimer = (data, mode = "STOCK") => {
        if (data.length !== 0) {
            let ofs = '', sep = '', diffClient = false, client = data[0].id_bijouterie
            Object.values(data).forEach(r => {
                if (client !== r.id_bijouterie) {
                    diffClient = true
                }
                ofs += sep + r.of
                sep = ','
            })
            if (!diffClient || mode ==='CUSTOM') window.open(`https://www.extensia-france.com/printers/stockProdPrinter.php?ofs=${ofs}&mode=${mode}`, "_blank")
            else alert('Impression bon de confié impossible car plusieurs clients sont présents')
        }
    }
    imprimerResa = (data) => {
        if (data.length !== 0) {
            let ofs = '', sep = ''
            Object.values(data).forEach(r => {
                ofs += sep + r.of
                sep = ','
            })
            window.open(`https://www.extensia-france.com/printers/reservationPrinter.php?ofs=${ofs}`, "_blank")
        }
    }
    tracerOf = (of) => {
        //this.props.getOfFromId(of)
        this.setState({ open: true, ofToTrace: of })
        //this.props.history.push("/of/tracer")
    }

printEtiquette = ()=>{
    // navigator.clipboard.writeText(this.etiquette());
        var output = '';
    // eslint-disable-next-line
        var errorString = '';
        var price = 0;

        const getLabelMetal = (metal) => {
            switch (metal) {
                case "OR BLANC":
                    return "OR B ";
                case "OR ROSE":
                    return "OR R ";
                case "OR JAUNE":
                    return "OR J ";
                case "ARGENT":
                    return "ARG ";
                case "BRONZE":
                    return "BRONZ ";
                default:
                    return metal + " ";
            }
        }

        this.state.stockProduit && Object.values(this.state.stockProduit).forEach(p => {
            if (p.leprix !== 0) price = p.leprix;
            else price = p.total3;

            let marque = "";
            if (p.nom_ligne === "EXTENSIA") marque = "EXTENSIA ";
            else marque = "ATC ";

            if (p.label_produit.length > 15) errorString += 'Attention OF N° ' + p.of + ' : Description trop grande\n';

            const var1 = (p.ref && (p.ref.includes('sp') || p.ref.includes('SP')) ? 'SP' : p.ref) + ' - ' + p.poids + ' Gr';
            const var2 = p.label_produit;
            const var3 = Math.round(price) < 6000 ? price + '/' + Math.round(price * 2.5) : price +' € HT';
            const var4 = p.prenom_ligne.toUpperCase();
            const var5 = getLabelMetal(p.lemetal) + p.of;
            const var6 = marque;

            const labelContent = `
          <div style="width: 43mm; height: 8mm; display: flex; justify-content: space-between; font-size: 2.1mm; font-weight: bolder; line-height: 1; box-sizing: border-box; padding-left: 7mm; padding-top:0.5mm;font-family: Arial Black, sans-serif;">
            <div style="width: 50%; text-align: left; margin: 0; padding: 0; box-sizing: border-box;">
              <p style="margin: 0; padding: 0; line-height: 1;">${var1}</p>
              <p style="margin: 0; padding: 0; line-height: 1;font-size: 1.6mm;">${var2}</p>
              <p style="margin: 0; padding: 0; line-height: 1;">${var3}</p>
            </div>
            <div style="width: 50%; text-align: left; margin: 0; padding: 0; box-sizing: border-box;">
              <p style="margin: 0; padding: 0; line-height: 1;">${var4}</p>
              <p style="margin: 0; padding: 0; line-height: 1;">${var5}</p>
              <p style="font-size: 2.5mm; margin: 0; padding: 0; line-height: 1;">${var6}</p>
            </div>
          </div>
        `;

            output += labelContent;
        });

        const printWindow = window.open('', '', 'width=800,height=600');
        printWindow.document.write('<html><head><title>Print</title><style>@page { margin: 0; } body { margin: 0; padding: 0; }</style></head><body>');
        printWindow.document.write(output);
        printWindow.document.write('</body></html>');
        printWindow.document.close();
        printWindow.print();
    }

    render() {
        const isMobile = isWidthDown('sm', this.props.width)

        const filterContent = (
            <>
                <div className={isMobile ? '' : 'col-sm'}>
                    <TreeClient handleChange={this.handleChangeClient} />
                </div>
                <div className={isMobile ? '' : 'col-sm'} style={{ padding: 4 }}>
                    <FilterInput label='Ref' type='text' onChange={this.onChange} />
                </div>
                <div className={isMobile ? '' : 'col-sm'} style={{ padding: 4 }}>
                    <FilterInput label='Of' type='text' onChange={this.onChange} />
                </div>
                <div className={isMobile ? '' : 'col-sm'} style={{ padding: 4 }}>
                    <FilterInput label='Plateau' type='text' onChange={this.onChange} />
                </div>
                <div className={isMobile ? '' : 'col-sm'} style={{ padding: 4 }}>
                    <FilterSelect label='Type' labelId='id_typ_prod' onChange={this.onChange} options={this.props.listeTypeProduit} />
                </div>
                <div className={isMobile ? '' : 'col-sm'} style={{ padding: 4 }}>
                    <FilterSelect label='Stade' labelId='id_stade' onChange={this.onChange} options={this.props.listeStade} />
                </div>
                <div className={isMobile ? '' : 'col-sm'} style={{ padding: 4 }}>
                    <FilterSelect label='Metal' labelId='id_type' onChange={this.onChange} options={this.props.listeMetaux} />
                </div>
                <div className={isMobile ? '' : 'col-sm'}>
                    <TreeClient handleChange={this.handleChangeReservation} defautLabel="Réservation Coll" />
                </div>
            </>
        )

        const allColumns = [
            { align: 'center', title: 'Image', field: 'image', render: rowData => <Image key={rowData.of} src={`${imagesRepo}thumbs.php?src=${rowData.image}&size=${isMobile ? 60 : 100}`} style={{ width: isMobile ? 60 : 100, height: isMobile ? 60 : 100 }} rounded /> },
            { align: 'left', title: 'Of', field: 'of', type: 'numeric' },
            { align: 'left', title: 'Métal', field: 'lemetal' },
            { align: 'left', title: 'Type', field: 'letype' },
            { align: 'left', title: 'Stade', field: 'lestade' },
            { align: 'left', title: 'Ref', field: 'ref' },
            { align: 'left', title: 'Description', field: 'description' },
            { align: 'left', title: 'Description Site', field: 'descOrdi', hidden: isMobile },
            { align: 'left', title: 'Etiquette', field: 'label_produit', hidden: isMobile },
            { align: 'left', title: 'Poids', field: 'poids', type: 'numeric' },
            { align: 'left', title: 'Doigt', field: 'ladim', type: 'numeric', hidden: isMobile },
            { align: 'left', title: 'Prix Fab', field: 'prix_r', hidden: isMobile },
            { align: 'left', title: 'Prix Repro', field: 'revient_piece', hidden: isMobile },
            { align: 'left', title: 'Prix', field: 'leprix' },
            { align: 'left', title: 'Prix Fiche', field: 'total3' },
            { align: 'left', title: 'Lieu', field: 'Nom_agence' },
            { align: 'left', title: 'Date Entrée', field: 'de', hidden: isMobile },
            { align: 'left', title: 'Plateau', field: 'plateau' },
            { align: 'left', title: 'Réservation', field: 'client_reserve' },
        ]

        const desktopActions = [
            {
                icon: 'query_stats',
                tooltip: 'Tracer Of', onClick: (e, rowData) => this.tracerOf(rowData.of),
                position: 'row'
            },
            {
                icon: 'edit',
                tooltip: 'Editer',
                onClick: (e, rowData) => this.editStock(rowData),
                position: 'row'
            },
            {
                icon: 'group_add',
                tooltip: 'Confier',
                onClick: (e, rowData) => this.setState({ editer: true, listeProduits: rowData }),
                position: 'toolbarOnSelect'
            },
            {
                icon: 'group_remove',
                tooltip: 'Supprimer Réservation',
                onClick: (e, rowData) => this.supprimerResa(rowData),
                position: 'toolbarOnSelect'
            },
            rowData => ({
                icon: 'run_circle',
                tooltip: 'Retour Stock',
                onClick: (e, rowData) => this.mouvementStock(rowData, '249'),
                position: 'toolbarOnSelect'
            }),
            rowData => ({
                icon: 'dashboard',
                tooltip: 'Gestion Plateau',
                onClick: (e, rowData) => this.mouvementPlateau(rowData),
                position: 'toolbarOnSelect'
            }),
            rowData => ({
                icon: 'receipt_long',
                tooltip: 'Facturer',
                onClick: (e, rowData) => this.facturer(rowData),
                position: 'toolbarOnSelect'
            }),
            {
                icon: 'add',
                tooltip: 'Ajouter',
                isFreeAction: true,
                onClick: (e) => this.add(),
                position: 'toolbar'
            },
            rowData => ({
                icon: 'history',
                tooltip: 'Historique',
                onClick: (e, values) => this.historique(values[0].of),
                disabled: rowData.length > 1,
                position: 'toolbarOnSelect'
            }),
            rowData => ({
                icon: 'local_printshop',
                tooltip: 'Imprimer',
                onClick: (e, values) => this.imprimer(values, 'CUSTOM'),
                position: 'toolbarOnSelect'
            }),
            rowData => ({
                icon: 'local_printshop',
                tooltip: 'Imprimer Plateau',
                onClick: (e, values) => this.imprimer(values, 'PLATEAU'),
                position: 'toolbarOnSelect'
            }),
            rowData => ({
                icon: 'print',
                tooltip: 'Imprimer Confie',
                onClick: (e, values) => this.imprimer(values),
                position: 'toolbarOnSelect'
            }),
            rowData => ({
                icon: 'print',
                tooltip: 'Imprimer Reservation',
                onClick: (e, values) => this.imprimerResa(values),
                position: 'toolbarOnSelect'
            })
        ]

        const mobileActions = [
            {
                icon: 'query_stats',
                tooltip: 'Tracer Of', onClick: (e, rowData) => this.tracerOf(rowData.of),
                position: 'row'
            },
        ]

        return (
            <div>
                {/* MOBILE : filtres en overlay */}
                {isMobile ? (
                    <>
                        <div style={{ display: 'flex', alignItems: 'center', padding: '8px 12px', gap: 8 }}>
                            <IconButton
                                onClick={() => this.setState({ filterOpen: true })}
                                style={{ backgroundColor: '#1976d2', color: '#fff', width: 44, height: 44 }}
                            >
                                <FilterListIcon />
                            </IconButton>
                            <span style={{ fontSize: 16, fontWeight: 500 }}>Stock Produit</span>
                            {this.state.cpt > 0 && <span style={{ fontSize: 13, color: '#666' }}>({this.state.cpt} rés.)</span>}
                        </div>

                        <div
                            onClick={(e) => e.stopPropagation()}
                            onTouchStart={(e) => e.stopPropagation()}
                            onMouseDown={(e) => e.stopPropagation()}
                            style={{
                                position: 'fixed',
                                top: 0, left: 0, right: 0, bottom: 0,
                                backgroundColor: '#fff',
                                zIndex: 1200,
                                display: this.state.filterOpen ? 'flex' : 'none',
                                flexDirection: 'column',
                                overflow: 'hidden',
                            }}
                        >
                            <div style={{
                                display: 'flex',
                                alignItems: 'center',
                                padding: '8px 12px',
                                borderBottom: '1px solid #e0e0e0',
                                backgroundColor: '#f5f5f5',
                            }}>
                                <IconButton onClick={() => this.setState({ filterOpen: false })}>
                                    <CloseIcon />
                                </IconButton>
                                <span style={{ fontSize: 18, fontWeight: 500, marginLeft: 8 }}>Filtres</span>
                            </div>
                            <div style={{ flex: 1, overflow: 'auto', padding: 12, display: 'flex', flexDirection: 'column', gap: 10 }}>
                                {filterContent}
                            </div>
                            <div style={{ padding: 12, borderTop: '1px solid #e0e0e0' }}>
                                <button
                                    className='btn btn-primary btn-lg btn-block'
                                    style={{ width: '100%' }}
                                    onClick={() => { this.afficher(); this.setState({ filterOpen: false }) }}
                                >
                                    Valider
                                </button>
                            </div>
                        </div>
                    </>
                ) : (
                    /* DESKTOP : filtres inline + boutons impression */
                    <div className='row' style={{ minHeight: 250, maxHeight: 250 }}>
                        {filterContent}
                        <div className="col-sm">
                            <button style={{ minHeight: 180 }} className='btn btn-primary btn-lg' onClick={this.afficher}>Afficher</button>
                        </div>
                        <div className="col-sm">
                            <button style={{ minHeight: 180, whiteSpace: 'normal', wordBreak: 'break-word', textAlign: 'center' }} className='btn btn-primary btn-lg' onClick={this.printEtiquette}>
                                Imprimer<br />Etiquette
                            </button>
                        </div>
                        <div className="col-sm">
                            <button style={{ minHeight: 180 }} className='btn btn-primary btn-lg' onClick={this.etiquette}>Etiquette</button>
                        </div>
                    </div>
                )}
                <div>
                    <MaterialTable
                        style={{ fontSize: isMobile ? 11 : 12 }}

                        columns={allColumns}

                        options={{
                            pageSize: isMobile ? 5 : 10,
                            selection: !isMobile,
                            actionsColumnIndex: -1,
                            exportButton: !isMobile,
                            exportAllData: !isMobile,
                            exportCsv: isMobile ? undefined : (allColumns, allData) => exportCsv(allColumns, allData, "stockProduit"),
                            autoSizeColumns: true,
                            padding: isMobile ? 'dense' : 'default',
                        }}

                        actions={isMobile ? mobileActions : desktopActions}
                        data={this.listeStockProduit()}
                        title={isMobile ? '' : 'Stock Produit'}

                        components={{
                            Toolbar: props => {
                                // Calcul des totaux pour les lignes sélectionnées
                                let totalRevient = 0, totalRevientReproduction = 0, totalVente = 0, poidsTotal = 0;
                                let cptRevientNull = 0, cptRevientReprodNull = 0;

                                if (props.selectedRows && props.selectedRows.length > 0) {
                                    props.selectedRows.forEach(p => {
                                        totalVente += parseFloat(p.leprix !== 0 ? p.leprix : p.total3);
                                        if (p.prix_r === 0) cptRevientNull++;
                                        totalRevient += parseFloat(p.prix_r);
                                        poidsTotal += parseFloat(p.poids);
                                        let revient_prod = 0;
                                        if (p.id_stade === 1) revient_prod = p.revient_mfs;
                                        else if (p.id_stade === 3) revient_prod = p.revient_cv;
                                        else if (p.id_stade === 4 || p.id_stade === 2) revient_prod = p.revient_piece;
                                        if (revient_prod === 0) cptRevientReprodNull++;
                                        totalRevientReproduction += parseFloat(revient_prod);
                                    });
                                }

                                return (
                                    <div>
                                        <MTableToolbar {...props} />
                                        <div style={{ display: 'flex', padding: '0px 25px' }}>
                                            <div style={{ flex: 1 }}>
                                                <h6>{this.state.cpt} Produits(s)</h6>
                                                <h6>Prix Revient : {euroFormat(this.state.totalRevient)} ({this.state.cptRevientNull} Prix à 0)</h6>
                                                <h6>Prix Revient Reproduction : {euroFormat(this.state.totalRevientReproduction)} ({this.state.cptRevientReprodNull} Prix à 0)</h6>
                                                <h6>Prix Vente : {euroFormat(this.state.totalVente)}</h6>
                                                <h6>Poids Total : {this.state.poidsTotal.toFixed(2)} Gr</h6>
                                            </div>
                                            {props.selectedRows && props.selectedRows.length > 0 && (
                                                <div style={{ flex: 1 }}>
                                                    <h6>{props.selectedRows.length} Produit(s) sélectionné(s)</h6>
                                                    <h6>Prix Revient : {euroFormat(totalRevient)} ({cptRevientNull} Prix à 0)</h6>
                                                    <h6>Prix Revient Reproduction : {euroFormat(totalRevientReproduction)} ({cptRevientReprodNull} Prix à 0)</h6>
                                                    <h6>Prix Vente : {euroFormat(totalVente)}</h6>
                                                    <h6>Poids Total : {poidsTotal.toFixed(2)} Gr</h6>
                                                </div>
                                            )}
                                        </div>
                                    </div>
                                );
                            },
                        }}
                        localization={localization}
                    />

                </div>


                <Dialog
                    open={this.state.open}
                    onClose={() => this.setState({ open: false })}
                    fullWidth={true}
                    maxWidth={'xl'}
                >
                    <DialogTitle id="form-dialog-title">Tracer OF</DialogTitle>
                    <DialogTitle style={{ position: 'absolute', right: 40 }} onClick={() => this.setState({ open: false })}><button className="btn btn-link">Fermer</button></DialogTitle>
                    <DialogContent>
                        <TracerOf of={this.state.ofToTrace} open={this.state.open} />
                    </DialogContent>

                </Dialog>
                <EnvoyerProduitsDialog
                    title={"Envoyer les produits sélectionnés"}
                    open={this.state.editer}
                    onClose={() => this.setState({ editer: false })}
                    choixClient={this.EnvoiClient}
                    handleSave={this.handleSave} />

                <Dialog
                    open={this.state.ajouter}
                    onClose={() => this.setState({ ajouter: false })}
                    fullWidth={true}
                    maxWidth={'sm'}
                    style={{ textAlign: "center" }}
                >
                    <DialogTitle id="form-dialog-title">Rentrer en Stock</DialogTitle>
                    <DialogContent >
                        <AddStockProduit />
                    </DialogContent>

                    <DialogActions>
                        <Button onClick={() => this.setState({ ajouter: false })} color="primary">
                            Fermer
                        </Button>
                    </DialogActions>
                </Dialog>

                <Dialog
                    open={this.state.modifier}
                    onClose={() => this.setState({ modifier: false })}
                    fullWidth={true}
                    maxWidth={'sm'}
                    style={{ textAlign: "center" }}
                >
                    <DialogTitle id="form-dialog-title">Editer</DialogTitle>
                    <DialogContent >
                        <EditStockProduit onSave={this.afficher} ligneStock={this.state.listeProduits} />
                    </DialogContent>

                    <DialogActions>
                        <Button onClick={() => this.setState({ modifier: false })} color="primary">
                            Fermer
                        </Button>
                    </DialogActions>
                </Dialog>

                <Dialog
                    open={this.state.historique}
                    onClose={() => this.setState({ historique: false })}
                    fullWidth={true}
                    maxWidth={'lg'}
                    style={{ textAlign: "center" }}
                >
                    <DialogTitle id="form-dialog-title">Historique</DialogTitle>
                    <DialogContent >
                        <HistoriqueStockProduit dataHisto={this.state.dataHistorique} />
                    </DialogContent>

                    <DialogActions>
                        <Button onClick={() => this.setState({ historique: false })} color="primary">
                            Fermer
                        </Button>
                    </DialogActions>
                </Dialog>


                <Dialog
                    open={this.state.showPlateau}
                    onClose={() => this.setState({ showPlateau: false })}
                    fullWidth={true}
                    maxWidth={'lg'}
                    style={{ textAlign: "center" }}
                >
                    <DialogTitle id="form-dialog-title">Mouvement Plateau</DialogTitle>
                    <DialogContent >
                    </DialogContent>
                    <div>
                        <TextField label="Plateau" variant="outlined"
                            value={this.state.plateauForUptade}
                            onChange={(e) => this.setState({ plateauForUptade: e.target.value })}
                        />
                        <button type="button" className="btn btn-link btn-sm" onClick={this.affectMouvementPlateau}>Enregistrer</button>
                    </div>
                    <DialogActions>
                        <Button onClick={() => this.setState({ showPlateau: false })} color="primary">
                            Fermer
                        </Button>
                    </DialogActions>
                </Dialog>

            </div >
        )
    }
}
const mapStateToProps = (state) => {
    return {
        listeTypeProduit: state.generalData.listeTypeProduit,
        listeStade: state.generalData.listeStade,
        listeMetaux: state.generalData.listeMetaux,
        listeClients: state.clients.listeClient,
    }
}
const mapDispatchToProps = {
    getTypeProduit,
    getStade,
    getMetaux,



}
export default connect(mapStateToProps, mapDispatchToProps)(withWidth()(StockPierre))